import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BASE_URL } from '@edl-development/edl-common';
import { PaetepApi } from '../paetep/paetep.api';
import { ComponentsReportDTO } from 'src/app/model/reporting/components-report-dto.model';

@Injectable()
export class ReportingApi extends PaetepApi {

    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getComponentReport(bid: number, schoolYear: string, ascending: boolean, orderBy?: string) {
        let params = new HttpParams()
            .append('ascending', String(ascending))

        if (orderBy) {
            params = params.append('orderBy', this.convertParam(orderBy));
        }

        return this.http.get<ComponentsReportDTO[]>(`${this.baseUri}/reporting/component/${bid}/${schoolYear}`, { params });
    }

    downloadComponentReport(bid: number, schoolYear: string, ascending: boolean, orderBy?: string) {
        let params = new HttpParams()
            .append('ascending', String(ascending))

        if (orderBy) {
            params = params.append('orderBy', this.convertParam(orderBy));
        }

        return this.http.get(`${this.baseUri}/reporting/component/download/${bid}/${schoolYear}`, { params, responseType: 'blob' });
    }
}